import { c as _c } from "react/compiler-runtime";
import { useMediaQuery } from "./use-media-query";
interface PointerCapability {
  supportsHover: boolean;
  isCoarsePointer: boolean;
  isTouchDevice: boolean;
}

/**
 * React hook that reports the current pointer/hover capability of the device.
 *
 * @returns Object containing:
 * - supportsHover: true when the primary input can meaningfully hover (e.g., mouse)
 * - isCoarsePointer: true when the primary pointer is coarse (e.g., touch)
 * - isTouchDevice: convenience property, true when device is primarily touch-based
 */
export function usePointerCapability() {
  const $ = _c(4);
  const supportsHover = useMediaQuery("(hover: hover)", true);
  const isCoarsePointer = useMediaQuery("(pointer: coarse)");
  const t0 = !supportsHover || isCoarsePointer;
  let t1;
  if ($[0] !== isCoarsePointer || $[1] !== supportsHover || $[2] !== t0) {
    t1 = {
      supportsHover,
      isCoarsePointer,
      isTouchDevice: t0
    };
    $[0] = isCoarsePointer;
    $[1] = supportsHover;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}